import React, { useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";
const DATA_ID = "data-id";
const SPACE_BAR = " ";
const SPLIT_CHARACTER = "";

let onChangeWait = null;

export function OverlaySlider(props) {
  const indexSize = props.highlight[1];
  const [startIndex, setStartIndex] = useState(props.highlight[0]);
  const [characterList] = useState(props.sequence.split(SPLIT_CHARACTER));

  const disableEvent = (event) => {
    const img = document.createElement("img");
    img.src = "";
    event.dataTransfer.setDragImage(img, 0, 0);
  };

  const dragOver = (event) => {
    event.preventDefault();
    const dataId = parseInt(event.target.getAttribute("data-id"));
    const startIndexLimit = props.sequence.length - indexSize;
    if (dataId > startIndexLimit) {
      setStartIndex(startIndexLimit);
    } else {
      setStartIndex(dataId);
    }
    setOnChange();
  };

  const setOnChange = () => {
    if (onChangeWait) {
      clearTimeout(onChangeWait);
    }
    onChangeWait = setTimeout(() => {
      props.onChange(getActiveSequence());
    }, props.onChangeTimeout);
  };

  const getActiveSequence = () => {
    const end = startIndex + indexSize;
    const text = props.sequence.substring(startIndex, end);
    return {
      text,
      start: startIndex,
      end,
    };
  };

  const listSequence = () => {
    let toHighlight = 0;
    const charTags = [];
    for (const ch in characterList) {
      const commonProps = {
        className: "ov-slider__sequence--character",
        key: ch,
        draggable: false,
        onDragStart: disableEvent,
        onDragOver: dragOver,
        dataId: ch,
        character: characterList[ch],
      };
      if (ch == startIndex) {
        toHighlight = indexSize;
      }
      if (toHighlight > 0) {
        commonProps.draggable = !props.disable;
        commonProps.className =
          "ov-slider__sequence--selected " + props.highlightClass;
        toHighlight -= 1;
      }
      charTags.push(<CharacterTag {...commonProps} />);
    }
    return charTags;
  };

  const sliderLabel = () => {
    if (props.label) {
      return <div className="ov-slider__label">{props.label}</div>;
    } else return null;
  };

  return (
    <div className="overlay-slider">
      <div className="ov-slider">
        {sliderLabel()}
        <div className="ov-slider__sequence">{listSequence()}</div>
      </div>
    </div>
  );
}

OverlaySlider.propTypes = {
  sequence: PropTypes.string.isRequired,
  highlight: PropTypes.array.isRequired,
  highlightClass: PropTypes.string,
  onChangeTimeout: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disable: PropTypes.bool,
  label: PropTypes.string,
};

OverlaySlider.defaultProps = {
  highlight: [0, 1],
  sequence: "sequence",
  highlightClass: "null",
  onChangeTimeout: 300,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: () => {},
  disable: false,
  label: "",
};

function CharacterTag(props) {
  const elementProps = (() => {
    const { className, draggable, onDragStart, onDragOver, dataId } = props;
    return { className, draggable, onDragStart, onDragOver, [DATA_ID]: dataId };
  })();
  if (props.character === SPACE_BAR) {
    return <span {...elementProps}>&nbsp;</span>;
  } else {
    return <span {...elementProps}>{props.character}</span>;
  }
}

CharacterTag.porpTypes = {
  className: PropTypes.string,
  draggable: PropTypes.bool,
  onDragStart: PropTypes.func,
  onDragOver: PropTypes.func,
  character: PropTypes.string,
  dataId: PropTypes.number,
};
